import { useMemo } from 'react';
import { BankRenderingInfo } from '../useBanksToRender';
import { useAllIfData } from 'src/hooks/query/ifData/useAllIfData';
import { useSpotMarketsLookup } from '../spotMarkets/useSpotMarketsLookup';

export const useMappedIfStakeBalances = () => {
	const spotMarketsLookup = useSpotMarketsLookup();
	const { data: ifStakeData } = useAllIfData();
	const mappedIfStakeBalances: Partial<BankRenderingInfo>[] = useMemo(() => {
		return Object.entries(ifStakeData).map(([_marketIndex, ifData]) => {
			return {
				base: ifData.userStake.currentStakeBigNum,
				quote: ifData.userStake.currentStakeNotionalValue,
				baseValue: ifData.userStake.currentStakeBigNum?.toNum() ?? 0,
				quoteValue: ifData.userStake.currentStakeNotionalValue?.toNum() ?? 0,
				market: spotMarketsLookup[ifData.marketIndex],
			};
		});
	}, [ifStakeData, spotMarketsLookup]);
	return mappedIfStakeBalances;
};
